<template>
  <div class="page final extrainfo">
    <main>
      <div class="citybg"></div>

      <levensweg-header icon="?"></levensweg-header>
      <header class="header--final">
        <div class="headercont">
          <h2 class="titleslide--final">Partenaires</h2>
          <p class="bodyslide--final"></p>
        </div>
        <div class="babylyingcontainer">
          <img
            src="./../assets/img/introbeeld.svg"
            class="introbeeld hidden-sm visible-md"
          />
        </div>
      </header>

      <section class="infosection">
        <div class="partnercontainer articlebody">
          <partner
            tekst="
            <p class='partnertitle'>Vives - Praktijk Gericht Wetenschappelijk Onderzoek</p>
            <p>dr. Ilse Delbaere</p>
            <p class='extraspacebottom'>Contact: <a href='mailto:ilse.delbaere@vives.be'>ilse.delbaere@vives.be</a></p>
            <p>Lisa Kerckhof</p>
            <p>Coördinator EC Zorginnovatie</p>"
          ></partner>
          <partner
            tekst="<p class='partnertitle'>Howest - Digital Design and Development</p><p><a href='https://www.devine.be/'>Devine</a></p><p>Fréderic Baert</p><p>
              Simon Dhaenens
            </p> <p>
              Robbe Callewaert
            </p>  "
          ></partner>
          <partner
            tekst="
            <p class='partnertitle'>Office de la naissance et de l’enfance (ONE)</p>
            <p>Direction Santé & Collège des Conseillers Gynécologues et sage-femmes</p>
            "
          ></partner>
          <partner
            tekst="
            <p class='partnertitle'>H.U.B – Hôpital Erasme</p>
            <p>Dr. Margherita Condorelli</p>
            <p class='extraspacebottom'>Service de Gynécologie et Obstétrique, Clinique de Fertilité</p>
            <p>
              Dr. David Pening
            </p>
            <p>
              Service de Gynécologie et Obstétrique, Clinique de Fertilité
            </p>
            "
          ></partner>
          <partner
            tekst="
            <p class='partnertitle'>Bioethics Institute Ghent</p>
            <p>Professor dr. Veerle Provoost</p>
            <p class='extraspacebottom'>Professor empirisch onderzoek in de bio-ethiek. Bioethics Institute Ghent.</p>
            <p>
              Professor dr. Heidi Mertes
            </p>
            <p>
              Professor in ethiek en president van 'De Maakbare Mens vzw'
            </p>
            "
          ></partner>
          <partner
            tekst="
            <p class='partnertitle'>UGent</p>
            <p>Professor dr. Petra De Sutter</p>
            <p class='extraspacebottom'>Afdelingshoofd Reproductieve geneeskunde</p>
            <p>Professor dr. Kristien Roelens</p>
            <p class='extraspacebottom'>Afdelingshoofd Verloskunde</p>
            <p>Joke Vandamme</p>
            <p>Wetenschappelijk medewerker relatie-en gezinsstudies</p>"
          ></partner>
          <partner
            tekst="
            <p class='partnertitle'>Sensoa</p>
            <p>Katrien Vermeire</p>
            <p>Beleidsmedewerker Reproductieve gezondheid</p>
            "
          ></partner>
          <partner
            tekst="
            <p class='partnertitle'>Kind en Gezin</p>
            <p>Evelyne Deguffroy</p>
            <p>Stafmedewerker gezondheidspromotie</p>
            "
          ></partner>
          <partner
            tekst="
            <p class='partnertitle'>VUB/ UZ Brussel</p>
            <p>Professor dr. Michel De Vos</p>
            <p>Afdelingshoofd Fertiliteitsdiagnostiek & - behandeling</p>
            "
          ></partner>
          <partner
            tekst="
            <p class='partnertitle'>De Verdwaalde Ooievaar</p>
            <p>Marijke Merckx</p>
            <p>Voorzitter</p>
            "
          ></partner>
          <partner
            tekst="
            <p class='partnertitle'>Vlaamse Wetenschappelijke Vereniging voor Jeugdgezondheidszorg</p>
            <p>Ann Keymeulen</p>
            "
          ></partner>
          <partner
            tekst="
            <p class='partnertitle'>BSRM: Belgian Society for Reproductive Medicine</p>
            "
          ></partner>
        </div>
      </section>

      <levensweg-footer class="footer" />
    </main>
  </div>
</template>

<script>
import Footer from "./../components/Footer";
import Header from "./../components/Header";
import Partner from "../components/Partner.vue";

export default {
  components: {
    "levensweg-footer": Footer,
    "levensweg-header": Header,
    partner: Partner,
  },
  mounted() {
    let section = this.$router.currentRoute.hash.replace("#", "");
    this.goto(section);
  },
  methods: {
    goto: function (refName) {
      var element = this.$refs[refName];

      if (element) {
        var top = element.offsetTop;
        window.scrollTo(0, top);
      } else {
        window.scrollTo(0, 0);
      }
    },
  },
};
</script>

<style>
.partnertitle {
  font-weight: bold;
  margin-bottom: 1rem;
}
.extraspacebottom {
  margin-bottom: 1.3rem;
}

.extrainfo a:link,
.extrainfo a:visited,
.extrainfo a:link:active,
.extrainfo a:visited:active {
  color: var(--blue);
}

.extrainfo .opsomming {
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-left: 3rem;
  list-style-type: disc;
}
.extrainfo .articlebody strong {
  font-weight: bold;
}

.extrainfo .infosection {
  margin-top: 5rem;
  margin-bottom: 7rem;
}
.extrainfo .articletitle {
  -webkit-column-span: all;
  column-span: all;
  margin-top: 0.5rem;
}
.specialcols {
  -webkit-column-count: 2;
  -moz-column-count: 2;
  column-count: 2;
}

.footer {
  margin-left: 1.8rem;
  margin-right: 1.8rem;
  margin-bottom: 4rem;
}
.rightblok {
  display: flex;
  flex-direction: column;

  margin-top: 8rem;
  margin-bottom: 6.2rem;
  margin-left: -1.8rem;
  margin-right: -1.8rem;
}
.parentsaside {
  align-self: center;
}
.rightblock__line {
  align-self: flex-end;
  position: absolute;
  background: url("../assets/img/line_path.svg") 0 0 no-repeat;
  background-position-x: right;
  width: 231px;
  height: 368px;
  z-index: -1;
  margin-top: -5.5rem;
}

.rightblok:after {
  content: "";
  position: absolute;
  z-index: -2;
  background: url("../assets/img/oval_end_side.svg") 0 0 no-repeat;
  background-position-x: right;
  width: 100%;
  height: 368px;
  margin-top: -3rem;
}

.ivf {
  width: 342px;
  height: 324px;
}

.babylyingcontainer {
  margin-left: calc(-26.13% * 2);
  margin-top: -4rem;
  margin-bottom: 8rem;
  z-index: -2;
}

.babylying {
  width: auto;
  height: 291px;
  object-fit: cover;
}

.ornamentline {
  background-image: url("../assets/img/line.svg");
  background-repeat: no-repeat;
  background-size: contain;
  width: 254.4px;
  height: 496px;
  position: absolute;
  z-index: -2;
}
.citybg {
  background-image: url("../assets/img/city.svg");
  background-repeat: no-repeat;
  background-position: -150px 82px;
  background-size: auto 364px;
  width: 100%;
  height: 100%;
  z-index: -2;
  position: absolute;
}

.header--final {
  display: flex;
  flex-direction: column;
}

.infosection {
  display: flex;
  flex-direction: column;
}

.articleblocks {
  display: flex;
  flex-direction: column;
}

.infosection,
.testimonialsection {
  margin-left: 1.8rem;
  margin-right: 1.8rem;
}

.sectiontitle {
  font-family: Montserrat;
  font-size: 1.1rem;
  text-transform: uppercase;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-bottom: 2rem;
  color: var(--orange);
}

.sectionintro {
  font-family: "Playfair Display";
  font-size: 2rem;
  color: var(--titleslidecolor);
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
}

.articletitle {
  font-family: "Playfair Display";
  font-size: 1.6rem;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--titleslidecolor);
  margin-top: 4rem;
  margin-bottom: 2rem;
}

.articletitle.second {
  margin-top: 3rem;
}

.articlebody {
  font-family: Montserrat;
  font-size: 1.3rem;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: var(--articlebodycolor);
  margin-right: 4.4rem;
}
.articlebody.noheading {
  margin-top: 3rem;
}
.titleslide--final {
  font-family: "Playfair Display";
  font-size: 6rem;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.08;
  letter-spacing: normal;
  color: var(--titleslidecolor);

  /*animation: fadeandmove 0.8s ease-out 0s;*/
  animation-name: movetitleslide1, fade;
  animation-timing-function: ease-out, ease-in;
  animation-duration: 0.5s, 1s;
  word-break: word-break;
  hyphens: manual;
}
.bodyslide--final {
  font-family: Montserrat;
  font-weight: 300;
  font-size: 1.3rem;
  line-height: 1.54;
  letter-spacing: normal;
  color: var(--bodyslidecolor);
  margin: 3.5rem 0 0 0;
  width: 26.6rem;
  animation-name: fade;
  animation-timing-function: ease-in;
  animation-duration: 0.5s;
  animation-delay: 0.8s;
  animation-fill-mode: backwards;
}
.btn--final a {
  margin-left: 0;
}

.header--final {
  margin: 14.4rem 14.6% 0 14.6%;
}

/* tablet */
@media only screen and (min-width: 768px) {
  .page {
    position: relative;
  }

  .babylyingcontainer {
    margin-left: 0;
    margin-bottom: 6rem;
    margin-right: 2rem;
    text-align: right;
  }
  .babylying {
    width: 80%;
    max-width: 449px;
    height: 80%;
    max-height: 374px;
  }
  .ivf {
    width: 308px;
    height: auto;
  }
  .infosection {
    flex-direction: row;
    align-items: flex-end;
  }
  .extrainfo .infosection::after {
    background: none;
  }
  .header--final {
    flex-direction: row-reverse;
    margin-left: 1.8rem;
    margin-right: 1.8rem;
    align-items: flex-end;
    margin-bottom: 8rem;
  }
  .header--final div {
    flex: 50%;
  }
  .sectionintro {
    width: 75%;
  }
  .extrainfo .sectionintro {
    width: 100%;
  }
  .rightblok:after {
    position: relative;

    margin-top: -100%;
  }
}

@media only screen and (min-width: 992px) {
  .infosection {
    align-items: flex-start;
  }

  .citybg {
    background-size: contain;
    background-position-x: 0px;
  }

  .infosection.plan {
    flex-direction: row-reverse;
    justify-content: space-between;
  }
  .articleblocks {
    flex-direction: row;
  }
  .sectionintro {
    width: 59.1rem;
  }

  .ornamentline {
    background-image: url("../assets/img/line.svg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    width: 100%;
    height: 50%; /*496px;*/
    position: absolute;
    z-index: -2;
  }
}

@media only screen and (min-width: 1200px) {
  .ornamentline {
    width: 100%;
    height: 496px;
  }

  .titleslide--final {
    font-size: 8rem;
    line-height: 1.06;
    width: 428px;
    max-width: 428px;
  }
  .babylyingcontainer {
    margin-right: 123px;
  }
  .header--final {
    margin-top: 81px;
  }

  .citybg {
    background-position-y: 18px;
    background-position-x: -83px;
  }

  .bodyslide--final {
    font-size: 1.5rem;
    width: 34.2rem;
    line-height: 1.47;
  }
  .sectiontitle {
    font-size: 1.3rem;
    margin-bottom: 2.2rem;
  }
  .sectionintro {
    font-size: 3rem;
  }
  .articletitle {
    font-size: 2rem;
    margin-top: 7.5rem;
  }
  .articletitle.second {
    margin-top: 7.5rem;
  }
  .articlebody {
    font-size: 1.5rem;
  }
  .plan .articlebody {
    width: 40.9rem;
  }
  .page.final {
    height: auto;
    max-width: 1200px;
    margin: 0 auto;
    padding-left: 83px;
    padding-right: 84px;
    overflow: hidden;
  }
  .btn--final {
    margin-top: 4rem;
  }
}
</style>
